import { publish } from '@alfa-bank/site-event-bus';
import type { Decorator, FormApi } from 'final-form';

import { decorateSubmit, useDecorator } from '../utils';

import type { ISubmitAnalytics } from './models';
import { GENDERS, ANALYTICS_FORM_FIELDS } from './config';

export const PUBLISHER_EVENT = 'form-send-metrics';

const getIncorrectFields = (errorFields: string[], form: FormApi<Record<string, unknown>>) =>
    errorFields
        .map(
            key =>
                form.getFieldState(key)?.data?.placeholder ||
                ANALYTICS_FORM_FIELDS[key as keyof typeof ANALYTICS_FORM_FIELDS]?.placeholder ||
                key
        )
        .join(', ');

/** Отправление аналитики */
export const useSendAnalytics = (
    analytics?: ISubmitAnalytics
): Decorator<Record<string, unknown>> =>
    useDecorator(
        decorateSubmit(form => {
            if (!analytics) return;
            const formState = form.getState();
            const errorFields = Object.keys(formState.errors);
            const { email, firstName, lastName, middleName } = formState.values;
            const data = {
                firstName,
                lastName,
                middleName,
                email,
            };

            if (errorFields.length) {
                if (!analytics.submitOnFail) return;

                publish(PUBLISHER_EVENT, {
                    ...analytics.submitOnFail,
                    data,
                    incorrect: getIncorrectFields(errorFields, form),
                });

                return;
            }
            if (!analytics.submit) return;

            publish(PUBLISHER_EVENT, {
                ...analytics.submit,
                data,
                gender: GENDERS[(formState.values.gender as keyof typeof GENDERS) || 'none'],
                subproduct: formState.values.card,
            });
        })
    );
